module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-31.430ef160.JPG";